export default __webpack_public_path__ + "static/media/kushki_logo_dark.cd51dae8.svg";